import { RecordingSettings, RoutingStrategy } from '@api/generated/graphql';
import ServiceQueue from '../../types/ServiceQueue';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { refreshQueueOnCacheMiss } from '../../lib/refreshQueue';
import { serviceState } from '../../lib/state';
import {
  discardStaleQueueDeltas,
  discardStaleQueueStatus,
} from '../../lib/coalesceWorkspaceEvents';

async function handleQueueCreated(event: Telecom.QueueCreatedEvent) {
  discardStaleQueueStatus(event.queueId);
  discardStaleQueueDeltas(event.queueId);
  const queue = getQueue(event.queueId);

  log('rtcs:queue:created:' + queue?.name, event);

  if (queue) {
    await refreshQueueOnCacheMiss(event.queueId);
    return;
  }

  const newQueue: ServiceQueue = {
    id: event.queueId,
    name: event.queueName,
    status: {
      abandonedSessions: 0,
      activeSessionCount: 0,
      averageWait: 0,
      estimatedWait: 0,
      longestWait: 0,
      missedSessions: 0,
      recipientCount: 0,
      totalSessions: 0,
      activeRecipientCount: 0,
      availableRecipientCount: 0,
    },
    memberIds: event.agentIds,
    sessions: [],
    inboundRecording: RecordingSettings.Automatically,
    routingStrategy: RoutingStrategy.MostIdle,
  };

  serviceState.queues = [...serviceState.queues, newQueue];
}

export default handleQueueCreated;
